import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classname';

class SearchableDropdown extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleInputValue: PropTypes.func.isRequired,
    clearValue: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    upwards: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.string,
  }

  static defaultProps = {
    clearValue: false,
    placeholder: '',
    upwards: false,
    disabled: false,
    value: '',
  }

  state = {
    value: '',
    valueText: '',
    custom: false,
    visibleOptions: false,
    isTyping: false,
  }

  constructor() {
    super();

    this.selectOption = this.selectOption.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
  }

  componentDidMount() {
    this.syncValueFromProps();
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearValue) {
      this.setState({ valueText: '', value: '', isTyping: false });
      this.props.updateClearValue(false);
      return;
    }

    // Handle external value changes OR options becoming available
    if (prevProps.value !== this.props.value || prevProps.options !== this.props.options) {
      this.syncValueFromProps();
    }
  }

  syncValueFromProps() {
    // Sync internal state with props value
    if (this.props.value && this.props.options.length > 0) {
      const selectedOption = this.props.options.find(option => option.sku === this.props.value);
      const valueText = selectedOption ? selectedOption.name : '';

      this.setState({
        value: this.props.value,
        valueText: valueText,
        isTyping: false
      });
    } else if (!this.props.value) {
      // Clear state if no value is provided
      this.setState({
        value: '',
        valueText: '',
        isTyping: false
      });
    }
  }

  selectOption(e) {
    const { value } = e.target.dataset;

    this.setState({ value, valueText: e.target.textContent, custom: false, isTyping: false }, () => {
      this.props.handleInputValue(this.state.value);
    });
  }

  handleInputChange(e) {
    const { value } = e.target;

    this.setState({ value, valueText: value, custom: true, isTyping: true }, () => {
      this.props.handleInputValue(this.state.valueText);
    });
  }

  handleInputFocus() {
    this.setState({ visibleOptions: true, isTyping: false, valueText: '' });
  }

  handleInputBlur() {
    // Restore the selected value text when blurring without selection
    const selectedOption = this.props.options.find(option => option.sku === this.state.value);
    const valueText = selectedOption ? selectedOption.name : '';

    this.setState({
      visibleOptions: false,
      valueText: valueText,
      isTyping: false
    });
  }

  renderOptions() {
    let filteredOptions = this.props.options;

    // Only filter when user is actively typing
    if (this.state.isTyping && this.state.valueText) {
      filteredOptions = this.props.options.filter((option) => {
        const name = option.name.toLowerCase();
        const value = this.state.valueText.toLowerCase();

        return name.includes(value);
      });
    }

    return filteredOptions.map((option) => {
      return <li key={option.sku} data-value={option.sku} onMouseDown={this.selectOption}>{option.name}</li>;
    });
  }

  render() {
    const options = this.renderOptions();
    const inputProps = {
      className: 'form-control',
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur,
      value: this.state.valueText,
      placeholder: this.props.placeholder,
      disabled: this.props.disabled,
    };
    const ulProps = {
      className: classname({
        'searchable-dropdown-options': true,
        'upwards': this.props.upwards,
      }),
    };

    return (
      <div className='searchable-dropdown'>
        <input {...inputProps} />

        {this.state.visibleOptions && options.length > 0 && (
          <ul {...ulProps}>
            {options}
          </ul>
        )}
      </div>
    );
  }
}

export default SearchableDropdown;
